export const home = {
  nav: {
    about: 'Giới thiệu',
    reviews: 'Đánh giá',
    methodology: 'Phương pháp'
  },
  hero: {
    title: 'Top 10 công cụ AI tốt nhất năm 2026',
    subtitle: 'So sánh trung thực và review độc lập',
    cta: 'Khám phá đánh giá'
  },
  intro: {
    label: 'Quy trình lựa chọn',
    title: 'Cách chúng tôi chọn công cụ AI tốt nhất',
    description: 'Chúng tôi đánh giá hàng trăm công cụ AI dựa trên thử nghiệm thực tế, phản hồi người dùng và phân tích toàn diện. Đội ngũ của chúng tôi dành hàng tuần để thử nghiệm từng công cụ nhằm cung cấp cho bạn những đánh giá chính xác, khách quan giúp bạn đưa ra quyết định sáng suốt.',
    process1: 'Nghiên cứu',
    process1desc: 'Nghiên cứu thị trường sâu rộng và phân tích phản hồi người dùng',
    process2: 'Thử nghiệm',
    process2desc: 'Thử nghiệm thực tế trong các tình huống thực tế',
    process3: 'Minh bạch',
    process3desc: 'Đánh giá trung thực không có mục đích ẩn giấu'
  },
  about: {
    mission: 'Sứ mệnh của chúng tôi là cung cấp các đánh giá trung lập, minh bạch và toàn diện về các công cụ AI. Chúng tôi cam kết giúp người dùng đưa ra quyết định sáng suốt bằng cách cung cấp đánh giá trung thực dựa trên thử nghiệm và phân tích kỹ lưỡng.',
    commitment1: 'Không có tuyên bố phóng đại hoặc thông tin gây hiểu lầm',
    commitment2: 'Phương pháp và tiêu chí đánh giá minh bạch',
    commitment3: 'Đánh giá độc lập không thiên vị',
    commitment4: 'Đề xuất tập trung vào người dùng để giúp bạn chọn đúng công cụ',
    team: 'Đội ngũ CTTNHHTTKTS247'
  },
  comparison: {
    title: 'So sánh Top 10 công cụ AI',
    subtitle: 'Phân tích chi tiết và xếp hạng trung thực',
    features: 'Tính năng chính',
    pros: 'Ưu điểm',
    cons: 'Nhược điểm',
    viewDetails: 'Xem chi tiết'
  },
  methodology: {
    title: 'Cách chúng tôi đánh giá công cụ AI',
    description: 'Quy trình đánh giá của chúng tôi nghiêm ngặt và minh bạch. Chúng tôi thử nghiệm từng công cụ một cách toàn diện để đảm bảo đánh giá chính xác và hữu ích.',
    phase1: 'Giai đoạn nghiên cứu',
    phase1desc: 'Chúng tôi tiến hành nghiên cứu thị trường toàn diện, phân tích đánh giá người dùng và xác định các tính năng chính quan trọng nhất đối với người dùng.',
    phase2: 'Quy trình thử nghiệm',
    phase2desc: 'Đội ngũ của chúng tôi thử nghiệm từng công cụ trong các tình huống thực tế, đánh giá hiệu suất, khả năng sử dụng, tính năng và giá trị đồng tiền.',
    phase3: 'Hệ thống chấm điểm',
    phase3desc: 'Chúng tôi sử dụng hệ thống chấm điểm chuẩn hóa dựa trên nhiều tiêu chí bao gồm chức năng, dễ sử dụng, giá cả và hỗ trợ khách hàng.'
  },
  faq: {
    title: 'Câu hỏi thường gặp',
    q1: 'Làm thế nào bạn chọn công cụ AI để đánh giá?',
    a1: 'Chúng tôi chọn công cụ AI dựa trên mức độ phổ biến, nhu cầu người dùng, sự đổi mới và tác động thị trường. Đội ngũ của chúng tôi nghiên cứu hàng trăm công cụ và chọn những công cụ phù hợp nhất để đánh giá toàn diện.',
    q2: 'Đánh giá của bạn có thiên vị không?',
    a2: 'Không. Chúng tôi duy trì sự độc lập hoàn toàn trong các đánh giá. Mặc dù chúng tôi có thể kiếm hoa hồng liên kết, điều này không ảnh hưởng đến xếp hạng hoặc đề xuất của chúng tôi. Chúng tôi cung cấp đánh giá trung thực chỉ dựa trên thử nghiệm và phân tích của chúng tôi.',
    q3: 'Bạn cập nhật đánh giá bao lâu một lần?',
    a3: 'Chúng tôi thường xuyên cập nhật đánh giá để phản ánh các tính năng mới, thay đổi giá cả và cải tiến. Các đánh giá chính được cập nhật hàng quý, trong khi các cập nhật nhỏ xảy ra khi cần thiết.',
    q4: 'Bạn có đảm bảo kết quả với các công cụ này không?',
    a4: 'Không. Chúng tôi không đảm bảo bất kỳ kết quả hoặc thu nhập cụ thể nào. Hiệu quả của bất kỳ công cụ AI nào phụ thuộc vào cách bạn sử dụng nó, nhu cầu cụ thể của bạn và nhiều yếu tố khác. Đánh giá của chúng tôi giúp bạn đưa ra quyết định sáng suốt, nhưng kết quả khác nhau.',
    q5: 'Liên kết liên kết hoạt động như thế nào?',
    a5: 'Khi bạn nhấp vào liên kết liên kết của chúng tôi và mua hàng, chúng tôi có thể kiếm hoa hồng mà không tốn thêm chi phí cho bạn. Điều này giúp hỗ trợ nỗ lực nghiên cứu và thử nghiệm của chúng tôi. Các mối quan hệ liên kết của chúng tôi không ảnh hưởng đến đánh giá trung thực của chúng tôi.',
    q6: 'Tôi có thể tin tưởng xếp hạng của bạn không?',
    a6: 'Có. Xếp hạng của chúng tôi dựa trên thử nghiệm thực tế sâu rộng, tiêu chí khách quan và sử dụng thực tế. Chúng tôi sử dụng quy trình đánh giá chuẩn hóa để đảm bảo tính nhất quán và công bằng trên tất cả các đánh giá.'
  },
  disclaimer: {
    title: 'Tuyên bố miễn trừ trách nhiệm liên kết',
    content1: 'Trang web này chứa các liên kết liên kết. Khi bạn nhấp vào các liên kết này và mua hàng, chúng tôi có thể kiếm hoa hồng mà không tốn thêm chi phí cho bạn. Điều này giúp hỗ trợ nghiên cứu và tạo nội dung của chúng tôi.',
    content2: 'Các mối quan hệ liên kết của chúng tôi không ảnh hưởng đến đánh giá hoặc xếp hạng của chúng tôi. Chúng tôi cung cấp đánh giá trung thực, không thiên vị dựa trên thử nghiệm và phân tích của chúng tôi. Chúng tôi chỉ đề xuất các công cụ mà chúng tôi tin rằng mang lại giá trị thực sự.',
    content3: 'Chúng tôi không đảm bảo bất kỳ kết quả, thu nhập hoặc kết quả cụ thể nào từ việc sử dụng các công cụ chúng tôi đánh giá. Kết quả khác nhau dựa trên hoàn cảnh cá nhân, nỗ lực và cách sử dụng công cụ. Luôn tiến hành nghiên cứu của riêng bạn trước khi đưa ra bất kỳ quyết định mua hàng nào.'
  },
  footer: {
    tagline: 'Cung cấp đánh giá công cụ AI trung thực và minh bạch để giúp bạn đưa ra quyết định sáng suốt.',
    contact: 'Thông tin liên hệ',
    quickLinks: 'Liên kết nhanh',
    privacy: 'Chính sách bảo mật',
    terms: 'Điều khoản dịch vụ',
    cookies: 'Chính sách cookie',
    contactUs: 'Liên hệ chúng tôi'
  },
  tools: {
    chatgpt: {
      description: 'AI đàm thoại tiên tiến được cung cấp bởi OpenAI, có khả năng hiểu và tạo văn bản giống con người cho nhiều tác vụ khác nhau.',
      features: ['Xử lý ngôn ngữ tự nhiên', 'Tạo mã code', 'Tạo nội dung', 'Hỗ trợ đa ngôn ngữ'],
      pros: ['Rất linh hoạt', 'Độ chính xác xuất sắc', 'Cập nhật thường xuyên'],
      cons: ['Yêu cầu đăng ký cho tính năng nâng cao', 'Có thể chậm trong giờ cao điểm'],
      price: 'Miễn phí - $20/tháng'
    },
    midjourney: {
      description: 'Công cụ tạo hình ảnh AI tạo ra tác phẩm nghệ thuật tuyệt đẹp từ mô tả văn bản.',
      features: ['Tạo hình ảnh chất lượng cao', 'Nhiều phong cách nghệ thuật', 'Thư viện cộng đồng', 'Quyền sử dụng thương mại'],
      pros: ['Chất lượng hình ảnh đặc biệt', 'Cộng đồng tích cực', 'Cải tiến thường xuyên'],
      cons: ['Giao diện dựa trên Discord', 'Không có gói miễn phí'],
      price: '$10 - $60/tháng'
    },
    jasper: {
      description: 'Trợ lý viết AI được thiết kế cho các nhà tiếp thị và người tạo nội dung để tạo bản sao tiếp thị chất lượng cao.',
      features: ['Mẫu bản sao tiếp thị', 'Tối ưu hóa SEO', 'Tùy chỉnh giọng điệu thương hiệu', 'Cộng tác nhóm'],
      pros: ['Xuất sắc cho nội dung tiếp thị', 'Nhiều mẫu', 'Tùy chọn tích hợp tốt'],
      cons: ['Giá cao hơn', 'Đường cong học tập cho người mới bắt đầu'],
      price: '$39 - $125/tháng'
    },
    copyai: {
      description: 'Công cụ viết bản sao AI giúp tạo nội dung tiếp thị, bài đăng blog và bản sao mạng xã hội nhanh chóng.',
      features: ['Hơn 90 mẫu viết bản sao', 'Hỗ trợ đa ngôn ngữ', 'Trình hướng dẫn bài đăng blog', 'Nội dung mạng xã hội'],
      pros: ['Giao diện thân thiện', 'Giá cả phải chăng', 'Đa dạng mẫu tốt'],
      cons: ['Chất lượng đầu ra khác nhau', 'Tùy chỉnh hạn chế'],
      price: 'Miễn phí - $49/tháng'
    },
    synthesia: {
      description: 'Nền tảng tạo video AI tạo video chuyên nghiệp với avatar AI từ kịch bản văn bản.',
      features: ['Avatar AI', 'Hỗ trợ đa ngôn ngữ', 'Avatar tùy chỉnh', 'Ghi màn hình'],
      pros: ['Không cần quay phim', 'Kết quả chuyên nghiệp', 'Tiết kiệm thời gian'],
      cons: ['Đắt cho cá nhân', 'Tùy chỉnh avatar hạn chế ở gói thấp hơn'],
      price: '$30 - $90/tháng'
    },
    grammarly: {
      description: 'Trợ lý viết AI kiểm tra ngữ pháp, chính tả, dấu câu và phong cách theo thời gian thực.',
      features: ['Kiểm tra ngữ pháp và chính tả', 'Đề xuất phong cách', 'Phát hiện đạo văn', 'Điều chỉnh giọng điệu'],
      pros: ['Độ chính xác cao', 'Dễ sử dụng', 'Hỗ trợ nhiều nền tảng'],
      cons: ['Tính năng cao cấp yêu cầu đăng ký', 'Có thể quá thận trọng'],
      price: 'Miễn phí - $30/tháng'
    },
    notion: {
      description: 'Không gian làm việc tất cả trong một với khả năng AI để ghi chú, quản lý dự án và cộng tác.',
      features: ['Trợ lý viết AI', 'Quản lý cơ sở dữ liệu', 'Cộng tác nhóm', 'Thư viện mẫu'],
      pros: ['Nền tảng linh hoạt', 'Tích hợp AI tốt', 'Xuất sắc cho nhóm'],
      cons: ['Đường cong học tập dốc', 'Tính năng AI yêu cầu gói trả phí'],
      price: 'Miễn phí - $15/tháng'
    },
    descript: {
      description: 'Công cụ chỉnh sửa âm thanh và video AI cho phép chỉnh sửa tệp phương tiện như tài liệu văn bản.',
      features: ['Chỉnh sửa dựa trên văn bản', 'Nhân bản giọng nói AI', 'Phiên âm tự động', 'Ghi màn hình'],
      pros: ['Cách tiếp cận chỉnh sửa sáng tạo', 'Tính năng tiết kiệm thời gian', 'Chất lượng âm thanh tốt'],
      cons: ['Tốn tài nguyên', 'Gói miễn phí hạn chế'],
      price: 'Miễn phí - $24/tháng'
    },
    runway: {
      description: 'Bộ công cụ sáng tạo AI cho chỉnh sửa video, tạo hình ảnh và tạo nội dung.',
      features: ['AI chỉnh sửa video', 'Tạo hình ảnh', 'Theo dõi chuyển động', 'Xóa màn hình xanh'],
      pros: ['Tính năng AI tiên tiến', 'Kết quả chuyên nghiệp', 'Cập nhật thường xuyên'],
      cons: ['Đắt cho người dùng thông thường', 'Yêu cầu phần cứng tốt'],
      price: '$12 - $76/tháng'
    },
    pictory: {
      description: 'Công cụ tạo video AI biến nội dung văn bản thành video hấp dẫn tự động.',
      features: ['Văn bản thành video', 'Phụ đề tự động', 'Tóm tắt video', 'Truy cập thư viện stock'],
      pros: ['Dễ sử dụng', 'Tạo video nhanh', 'Tốt cho mạng xã hội'],
      cons: ['Tùy chỉnh hạn chế', 'Watermark trên gói miễn phí'],
      price: '$19 - $99/tháng'
    }
  }
};